import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import "./index.css"
import { ContextProvider } from './Context';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import './styles.css';
import purple from '@material-ui/core/colors/purple';

const dark = {

  palette: {

    type: 'dark',
    primary: {
      light: '#757ce8',
      main: '#2196F3',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#EF5350',
      main: '#EF5350',
      dark: '#EF5350',
      contrastText: '#fff',
    },

  },

}

const appliedTheme = createMuiTheme(dark)

ReactDOM.render(
  <ThemeProvider theme={appliedTheme}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);
